import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import DxDataTable from 'components/DxDataTable'
import { ContentBlockLoading } from 'components/ContentBlock'
import { columns, generateDynamicHeaders } from './dxColumns'

export default function StatisticData({ data, filter, loading, called, status, settings, onSaveSettings }) {
	const [t] = useTranslation()
	const groupsColumns = generateDynamicHeaders(data, 'salesGroups')
	const tableColumns = filter.isSalesGroup ? [...columns(t), ...groupsColumns] : columns(t)

	return called ?
		<Fragment>
			<ContentBlockLoading blockId='1' alwaysExpanded isLoading={loading} showHeader={false}>
				<DxDataTable
					data={data}
					columns={tableColumns}
					settings={settings}
					height={508}
					label={t('statistic_section.sub_sections.shop_statistic')}
					manualGroup
					customStoring
					withSearch={false}
					excelExport
					onSaveSettings={onSaveSettings}
					{...status === 'ERROR' && { noDataText: t('server_errors.request_failed') }}
				/>
			</ContentBlockLoading>
		</Fragment> : <></>
}
